var React = require('react');

function ArrowHeaderDropdown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z","fill":"#C4C4C4","key":0}),React.createElement("path",{"d":"M17 9L11.1 14.8H11L5 9H7.1L11 12.9L14.9 9H17Z","fill":"#C4C4C4","key":1})]);
}

ArrowHeaderDropdown.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = ArrowHeaderDropdown;

ArrowHeaderDropdown.default = ArrowHeaderDropdown;
